import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { withDefault } from "../../../utils/withDefault";

interface Props {
  comment?: string;
}

const SearchModalCardNotFound = (props: Props) => {
  const comment = withDefault(props.comment, translate(STRINGS.NOT_FOUND));

  return <div className="_noResults">{comment}</div>;
};

export default SearchModalCardNotFound;
